import store from '../store';
export const quillConfig = {
  modules: {
    toolbar: [
      [{ size: ['small', false, 'large'] }],
      ['bold', 'italic'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      // ['link', 'image'],
      // ['clean']
    ],

    history: {
      delay: 1000,
      maxStack: 50,
      userOnly: false
    }
  }
};

export const getCommentQuillConfig = allUserObj => {
  return {
    modules: {
      toolbar: false,

      history: {
        delay: 1000,
        maxStack: 50,
        userOnly: false
      },
      mention: {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ['@'],
        source: function(searchTerm, renderList, mentionChar) {
          let atValues = [];
          const projectDetails = store.state.projectDetails;
              if (!projectDetails || !allUserObj) {
                atValues = [];
              }
              projectDetails.collaborators.forEach(collab => {
                if (collab !== store.state.userInformation.userId) {
                  let user = allUserObj[collab.toLowerCase()];
                  if (user !== undefined) {
                    atValues.push({
                      value: (user?.firstName || '') + ' ' + (user?.lastName || ''),
                      userName:
                        (user?.firstName || '') + ' ' + (user?.lastName || ''),
                      userId: user?.id || '',
                      id: user?.id || ''
                    });
                  }
                }
              });
          let values;

          if (mentionChar === '@') {
            values = atValues;
          } else {
            // values = hashValues;
          }

          if (searchTerm.length === 0) {
            renderList(values, searchTerm);
          } else {
            const matches = [];
            for (let i = 0; i < values.length; i++) {
              if (
                ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
              ) {
                matches.push(values[i]);
              }
            }
            renderList(matches, searchTerm);
          }
        }
      }
    },
    placeholder: 'Add your reply here...'
  };
};
